function validateRequired(value) {
    let error;
    if (!value) {
        error = 'Este campo es obligatorio';
    }
    return error;
}

export default validateRequired;